import { Button } from '@/components/ui/button';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@/components/ui/modal';
import TextField from '@/components/ui/text-field';

interface AddSchoolModalProps {
  open: boolean;
  newSchoolName: string;
  onClose: () => void;
  onNewSchoolNameChange: (value: string) => void;
  onAddSchool: () => void;
}

const AddSchoolModal: React.FC<AddSchoolModalProps> = ({
  open,
  newSchoolName,
  onClose,
  onNewSchoolNameChange,
  onAddSchool,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      name="add-school"
      className="modal--glass"
    >
      <ModalHeader className="modal_header">
        <h2>Add School</h2>
      </ModalHeader>
      <ModalBody className="modal_content">
        <TextField
          context="modal"
          label="School Name"
          value={newSchoolName}
          onChange={(e) => onNewSchoolNameChange(e.target.value)}
        />
      </ModalBody>
      <ModalFooter className="modal_actions">
        <Button
          context="modal"
          variant="outline"
          onClick={onClose}
          tabIndex={0}
          aria-label="Cancel"
        >
          Cancel
        </Button>
        <Button
          className="button"
          context="modal"
          onClick={onAddSchool}
          disabled={!newSchoolName}
          tabIndex={0}
          aria-label="Add School"
        >
          Add School
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddSchoolModal;
